import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Link } from '@bibliocommons/base-links';
import { ShelfMap } from '@bibliocommons/base-icons';
import { libraryShape } from '@bibliocommons/bc-prop-types';

import './StackMapLink.scss';

export default class StackMapLink extends React.PureComponent {
  handleClick = shelfMapText => {
    const { stackMapActions, bibItem, currentLibrary, handleClick, trackShelfMapClick } = this.props;
    stackMapActions.openStackMap(currentLibrary.get('stackMap'), bibItem);

    trackShelfMapClick(shelfMapText);

    if (handleClick) handleClick();
  };

  render() {
    const { bibItem, currentLibrary, intl } = this.props;
    const stackMapSettings = currentLibrary.get('stackMap');
    const shelfMapText = intl.formatMessage({ id: 'shelf_map' });

    const stackMapEnabled =
      stackMapSettings.get('enabled') &&
      stackMapSettings.get('supportedBranches').includes(bibItem.getIn(['branch', 'name'])) &&
      bibItem.get('collection') &&
      bibItem.get('callNumber') &&
      bibItem.getIn(['availability', 'statusType']) !== 'UNAVAILABLE' &&
      bibItem.getIn(['availability', 'statusType']) !== 'ON_ORDER';

    if (stackMapEnabled) {
      return (
        <Link
          className="cp-stack-map-link"
          href="#stack-map-display"
          dataKey="stack-map-link"
          handleClick={() => this.handleClick(shelfMapText)}
          preventDefault
        >
          <ShelfMap />
          {shelfMapText}
        </Link>
      );
    }

    return null;
  }
}

StackMapLink.propTypes = {
  bibItem: ImmutablePropTypes.map.isRequired,
  currentLibrary: libraryShape.isRequired,
  handleClick: PropTypes.func,
  stackMapActions: PropTypes.objectOf(PropTypes.func).isRequired,
  trackShelfMapClick: PropTypes.func.isRequired,
  intl: PropTypes.object.isRequired
};
